import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 768 926 504 926C240 926 82 771 82 558ZM205 522L415 732L793 354L737 299L414 622L260 467Z" })
});
export default SvgCheckmarkCircle;
